// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZSMG","input":"styles_input__1EDTg"};